export const Logopictures = [
    {
        id: 1,
        img: '../images/client-logos/gulf.png',
        title: 'Gulf Oil',
    },
    {
        id: 2,
        img: '../images/client-logos/nirma-university.png',
        title: 'Nirma University',
    },
    {
        id: 3,
        img: '../images/client-logos/hocco.svg',
        title: 'Hocco',
    },
    {
        id:4,
        img: '../images/client-logos/gp.png',
        title: 'GP',
    },

    {
        id: 5,
        img: '../images/client-logos/mica.png',
        title: 'MICA',
    },
    {
        id: 6,
        img: '../images/client-logos/adani.png',
        title: 'Adani',
    },
    {
        id: 7,
        img: '../images/client-logos/national-health-mission.png',
        title: 'National Health Mission',
    },  
    {
        id: 8,
        img: '../images/client-logos/hm.png',
        title: 'Havmore Ice Cream',
    },
    {
        id: 9,
        img: '../images/client-logos/vadilal.png',
        title: 'Vadilal',
    },
    {
        id: 10,
        img: '../images/client-logos/btipl.png',
        title: 'BTIPL',
    },
    {
        id: 11,
        img: '../images/client-logos/pdeu.png',
        title: 'PDEU',
    },
    {
        id: 12,
        img: '../images/client-logos/katria.png',
        title: 'Katria',
    },
    {
        id: 13,
        img: '../images/client-logos/green-cross.png',
        title: 'Green Cross',
    },
    

]